import logo from './certifiedLogo.png';

import classes from './index.module.scss';

const CertifiedLogo = () => {
  return <img src={logo} title='GHMT Premium' alt='GHMT Premium Logo' className={classes.logo} />
}

export default CertifiedLogo;